import { render, staticRenderFns } from "./gasTest.vue?vue&type=template&id=2b65ad2d&scoped=true&"
import script from "./gasTest.vue?vue&type=script&lang=js&"
export * from "./gasTest.vue?vue&type=script&lang=js&"
import style0 from "./gasTest.vue?vue&type=style&index=0&id=2b65ad2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b65ad2d",
  null
  
)

export default component.exports